import React from 'react';
import { animated, useSpring } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import MarkdownView from 'react-showdown';

import Button from '../../button/button';

import { fadeInFromBelow } from '../../../services/configs/animations/component-animation.config';

import { SplitColumnType, TextColumn as TextColumnType } from '../../../models/strapi/split_column';

import { colors } from '../../../shared/colors';

import * as styles from './column.module.scss';

interface Props {
    data: TextColumnType;
    isImagePadded: boolean;
    isLeftColumn: boolean;
    variant: SplitColumnType['variant'];
    bothTextColumns: boolean;
    usingMouse: boolean;
    onClickFunctions: {
        [key: string]: () => void;
    };
}

const TextColumn = ({
    data,
    isImagePadded,
    isLeftColumn,
    variant,
    bothTextColumns,
    usingMouse,
    onClickFunctions
}: Props) => {
    const [ref, inView] = useInView({ threshold: 0, triggerOnce: true });
    const animationProps = useSpring(fadeInFromBelow({ inView }));
    const height = { height: '100%' };
    const variantClass = isImagePadded && variant === 'sixty_fourty' ? 'sixtyFourty' : '';
    const containerClass =
        variant === 'sixty_fourty'
            ? isLeftColumn
                ? 'leftColumnSixtyFourtyTextContainer'
                : 'rightColumnSixtyFourtyTextContainer'
            : variant === 'fourty_sixty'
            ? isLeftColumn
                ? 'leftColumnFourtySixtyTextContainer'
                : 'rightColumnFourtySixtyTextContainer'
            : variant === 'fifty_fifty'
            ? isLeftColumn && bothTextColumns
                ? 'halfLeftColumn'
                : !isLeftColumn && bothTextColumns
                ? 'halfRightColumn'
                : 'textColumnContainer'
            : 'textColumnContainer';
    if (!data.text) {
        // eslint-disable-next-line no-console
        console.error('Web-Gatsby component library: missing text in SplitColumn');
    }
    return (
        <animated.div
            style={{
                ...animationProps,
                ...height
            }}>
            <div className={`${styles[containerClass]} ${(styles as any)[variantClass]}`} ref={ref}>
                {data.text
                    ? data.text.map((text, i) => {
                          const alignStyle = text.textAlign
                              ? ((text.textAlign + 'Align') as
                                    | 'rightAlign'
                                    | 'centerAlign'
                                    | 'leftAlign')
                              : 'leftAlign';
                          const fontClass = text.font ? text.font : 'curaleaf';
                          const classes = `${styles[alignStyle]} ${styles[fontClass]}`;
                          return (
                              <div
                                  key={i}
                                  className={classes}
                                  style={{
                                      color: text.fontColor ? colors[text.fontColor] : colors.teal
                                  }}>
                                  <MarkdownView markdown={text.value} />
                              </div>
                          );
                      })
                    : null}
                {data.button
                    ? data.button.map((button, i) => (
                          <div className={styles.button} key={i}>
                              <Button
                                  linkHref={button.href}
                                  linkColor={button.linkColor}
                                  label={button.label}
                                  onClick={onClickFunctions[button.clickType]}
                                  variant={button.variant}
                                  size='sm'
                                  usingMouse={usingMouse}
                              />
                          </div>
                      ))
                    : null}
            </div>
        </animated.div>
    );
};

export default TextColumn;
